import { Session } from '@/types/session.types';
import { Post } from '../helpers';
import { CreateSession } from '@/types/create-project.types';

type AddNewSessionPayload = {
  session: CreateSession;
  event: number;
  eventUuid: string;
  channel: number;
};

const AddNewSession = async (payload: AddNewSessionPayload): Promise<Session> => {
  return Post({
    path: '/v3/admin/event/session',
    body: payload,
  });
};

export default AddNewSession;
